import _, { isObject } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState, startTransition } from "react";
import { Link } from "react-router-dom";
import { elasticSearchByTitleRaw, elasticSearchByTextRaw } from "src/api/elasticsearch";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { SearchUI } from "src/components/ui/Search";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import useDebounce from "src/hooks/useDobounce";
import ExportToExcel from "src/modules/exelExport";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { addUsers } from "src/modules/users/actions";
import CustomCheckbox from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomCheckbox";
import { RootState } from "src/store/rootReducer";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { buildDocumentSearchFilter, isCodeIndexQuery } from "src/utils/searchFilter.utils";
import LoadingOpBg from "src/components/LoadingOpBg";
import {
  collectionsListName,
  departmentsListName,
  dependenciesListName,
  linesListName,
  MDWorkstationListName,
  myDocumentsListName,
  myDocumentsWithRelationsListName,
  processesListName,
  sectorsListName,
  siteUrl,
  statusesListName,
  typesListName,
} from "src/api/config";
import { ReportIcon } from "src/components/ui-icons/card/ReportIcon";
import { FileIcon } from "src/components/ui-icons/upload";
import ReportDocumentsTable from "src/components/tables/ReportDocumentsTable";
import { docStatuses } from "src/api/config/systemSwitch";
import { selectCurrentUser } from "src/modules/users/selector";
import { FavoriteButtonFilters } from "src/modules/favoriteFilters/md/FavoriteButtonFilters";
import { FavoriteFiltersList } from "src/modules/favoriteFilters/md/FavoriteFiltersList";
import { Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import { exportExcelFile } from "src/modules/exelExport/exelExport";

function ReportDocumentsFilters({
  setFilters,
  setSearchQuery,
  setGetListDocuments,
  searchQuery,
  searchByPartialMatch,
  searchByContent,
  filters,
  setDisplayFilters,
  setFiltersParams,
  filtersParams,
  defaultUserFilter,
  userFilterCheck,
  reRenderUserFilter,
}: any) {
  const [defaultValues, setDefaultValues] = useState({});
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const [fields, setFields] = useState<any>([
    {
      type: "checkbox",
      require: false,
      key: "Status",
      isFilter: true,
      title: "Статус документа",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Collection",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Коллекция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Department",
      isFilter: true,
      searchInFilterCheckbox: true,
      title: "Подразделения/Функция",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Sector",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Колонна/Направление/Отдел",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Process",
      searchInFilterCheckbox: true,
      title: "Блок колонны/Участок",
      isFilter: true,
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "DocType",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Тип документа",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "checkbox",
      isFilter: true,
      require: false,
      title: "Рабочее место",
      key: "WorkPlaces",
      width: "w-full",
    },
    {
      type: "checkbox",
      require: false,
      key: "Lines",
      searchInFilterCheckbox: true,
      isFilter: true,
      title: "Линия розлива",
      placeholder: "Не выбрано",
      width: "w-full",
    },
    {
      type: "radio",
      require: false,
      key: "Critical",
      isFilter: true,
      title: "Критичность",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      isFilter: true,
      title: "Название оборудования",
      searchApiField: "Title",
      key: "Equipments_Title",
      placeholder: "Введите название",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Производитель оборудования",
      key: "Equipments_Manufacturer",
      searchApiField: "Manufacturer",
      isFilter: true,
      placeholder: "Введите производителя",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Модель оборудования",
      key: "Equipments_Model",
      searchApiField: "Model",
      isFilter: true,
      placeholder: "Введите модель",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "Тип оборудования",
      key: "Equipments_TypeEquipment",
      searchApiField: "TypeEquipment",
      isFilter: true,
      placeholder: "Введите тип",
      width: "w-full",
    },
    {
      type: "checkbox_search",
      require: false,
      title: "SAP № технического места",
      key: "Equipments_SAP",
      searchApiField: "SAP",
      isFilter: true,
      placeholder: "Введите SAP",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "ResponsibleForRevisionEmail",
      title: "Ответственный за пересмотр",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "peoplePicker",
      require: false,
      single: true,
      isFilter: true,
      key: "AuthorEmail",
      title: "Создатель",
      current: false,
      placeholder: "Введите имя или фамилию",
      width: "w-full",
    },
    {
      type: "dateRange",
      require: false,
      key: "DateForRevision",
      title: "Пересмотр документа",
      isFilter: true,
      placeholder: "дд.мм.гггг",
      width: "w-full",
    },
  ]);
  const [reportDocumentsFilter, setReportDocumentsFilter] = useState<any>({});
  const [dependenceFields, setDependenceFields] = useState<any>({
    Collection: null,
    Department: null,
    Sector: null,
    Process: null,
  });
  const collections: any = useAppSelector((state) => selectItems(state, collectionsListName));
  const departments: any = useAppSelector((state) => selectItems(state, departmentsListName));
  const sectors: any = useAppSelector((state) => selectItems(state, sectorsListName));
  const processes: any = useAppSelector((state) => selectItems(state, processesListName));
  const types: any = useAppSelector((state) => selectItems(state, typesListName));
  const lines: any = useAppSelector((state) => selectItems(state, linesListName));
  const statuses: any = useAppSelector((state) => selectItems(state, statusesListName));
  const [customLoading, setCustomLoading] = useState(true);
  const [resetFilters, setResetFiters] = useState(false);
  const [workplaces, setWorkplaces] = useState<any>([]);
  const [isDefaultDepartment, setDefaultDepartment] = useState(0);

  //Формируем данные фильтры по умолчанию
  useEffect(() => {
    setCustomLoading(true);
    const tempFieldsForm = [...fields];
    for (let i = 0; i < tempFieldsForm.length; i++) {
      if (tempFieldsForm[i]["key"] === "Collection") {
        tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
          return {
            id: collection.ID,
            name: collection.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Status") {
        tempFieldsForm[i]["optionsInputs"] = statuses
          .filter(
            (status: any) =>
              status.ID === docStatuses.revision ||
              status.ID === docStatuses.review ||
              status.ID === docStatuses.cancel ||
              status.ID === docStatuses.approval ||
              status.ID === docStatuses.archive ||
              status.ID === docStatuses.public,
          )
          .map((status: any) => {
            return {
              id: status.ID,
              name: status.Title,
              disabled: false,
            };
          });
      }
      if (tempFieldsForm[i]["key"] === "Department") {
        tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
          return {
            id: department.ID,
            name: department.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Sector") {
        tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
          return {
            id: sector.ID,
            name: sector.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Process") {
        tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
          return {
            id: process.ID,
            name: process.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "DocType") {
        tempFieldsForm[i]["optionsInputs"] = types.map((type: any) => {
          return {
            id: type.ID,
            name: type.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "Lines") {
        tempFieldsForm[i]["optionsInputs"] = lines.map((line: any) => {
          return {
            id: line.ID,
            name: line.Title,
            disabled: false,
          };
        });
      }
      if (tempFieldsForm[i]["key"] === "WorkPlaces") {
        tempFieldsForm[i]["optionsInputs"] = workplaces
          .map((place: any) => {
            return {
              id: place.ID,
              name: `${place.Location.get_lookupValue()}_${place.Workstation}`,
              disabled: false,
            };
          })
          .sort((a: any, b: any) => a.name.localeCompare(b.name, "ru", { sensitivity: "base" }));
      }
      if (tempFieldsForm[i]["key"] === "Critical") {
        tempFieldsForm[i]["optionsInputs"] = ["Критичный", "Не критичный"];
      }
    }
    setFields([...tempFieldsForm]);
    setCustomLoading(false);
  }, [collections, departments, sectors, processes, types, lines, workplaces, statuses]);

  useEffect(() => {
    if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
      setCustomLoading(true);
      let filtersDependDocuments: any = {};
      const tempFieldsForm = [...fields];
      Object.keys(dependenceFields).map((key) => {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === key) {
            tempFieldsForm[i]["optionsInputs"] = tempFieldsForm[i]["optionsInputs"].map((option: any) => {
              return {
                id: option.id,
                name: option.name,
                disabled: false,
              };
            });
          }
        }
      });

      if (dependenceFields["Collection"]) {
        for (let i = 0; i < tempFieldsForm.length; i++) {
          if (tempFieldsForm[i]["key"] === "Lines") {
            tempFieldsForm[i]["optionsInputs"] = lines
              .filter((line: any) =>
                dependenceFields["Collection"].some((depend: any) => depend.id === line.Collection.ID),
              )
              .map((line: any) => {
                return {
                  id: line.ID,
                  name: line.Title,
                  disabled: false,
                };
              });
          }
        }
      }

      Object.keys(dependenceFields).map((key) => {
        if (dependenceFields[key] && dependenceFields[key].length > 0) {
          filtersDependDocuments[key] = dependenceFields[key].map((item: any) => item.id);
        }
      });
      if (Object.keys(filtersDependDocuments).length === 0) {
        setFields([...tempFieldsForm]);
        setCustomLoading(false);
      } else {
        if (Object.keys(filtersDependDocuments).length > 0) {
          //Устанавливаем зависимости в фильтрах
          getItemsRequest({
            listName: dependenciesListName,
            filters: filtersDependDocuments,
            filtersType: "or",
            sortOrder: { name: "SortDepend", asc: true },
          }).then((results) => {
            const dependDocuments = [...results.items];
            const collectionIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Collection.get_lookupId()),
              _.isEqual,
            );
            const departmentIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Department.get_lookupId()),
              _.isEqual,
            );
            const sectorIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Sector.get_lookupId()),
              _.isEqual,
            );
            const processIds = _.uniqWith(
              dependDocuments.map((item: any) => item.Process.get_lookupId()),
              _.isEqual,
            );
            for (let i = 0; i < tempFieldsForm.length; i++) {
              if (tempFieldsForm[i]["key"] === "Collection") {
                if (!filtersDependDocuments["Collection"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = collections.map((collection: any) => {
                    return {
                      id: collection.ID,
                      name: collection.Title,
                      disabled: false, //collectionIds.indexOf(collection.ID) === -1,
                      hide: collectionIds.indexOf(collection.ID) === -1
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Department") {
                if (!filtersDependDocuments["Department"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = departments.map((department: any) => {
                    return {
                      id: department.ID,
                      name: department.Title,
                      disabled: false, //departmentIds.indexOf(department.ID) === -1,
                      hide: departmentIds.indexOf(department.ID) === -1,
                      user_Department: false //department.User_Department,
                    };
                  });
                  tempFieldsForm[i]["optionsInputs"].forEach((department: any) => {
                    if (
                      department.user_Department &&
                      department.user_Department.indexOf(currentUser.department) !== -1 &&
                      department.disabled
                    ) {
                      setDefaultDepartment(department.id);
                    }
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Sector") {
                if (!filtersDependDocuments["Sector"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = sectors.map((sector: any) => {
                    return {
                      id: sector.ID,
                      name: sector.Title,
                      disabled: false, //sectorIds.indexOf(sector.ID) === -1,
                      hide: sectorIds.indexOf(sector.ID) === -1,
                    };
                  });
                }
              }
              if (tempFieldsForm[i]["key"] === "Process") {
                if (!filtersDependDocuments["Process"] || Object.keys(filtersDependDocuments).length > 1) {
                  tempFieldsForm[i]["optionsInputs"] = processes.map((process: any) => {
                    return {
                      id: process.ID,
                      name: process.Title,
                      disabled: false, //processIds.indexOf(process.ID) === -1,
                      hide: processIds.indexOf(process.ID) === -1
                    };
                  });
                }
              }
            }
            setFields([...tempFieldsForm]);
            setCustomLoading(false);
          });
        }
      }
    }
  }, [dependenceFields, currentUser]);

  useEffect(() => {
    setDependenceFields({
      Collection: null,
      Department: null,
      Sector: null,
      Process: null,
    });
  }, [resetFilters]);

  useEffect(() => {
    getItemsRequest({
      listName: MDWorkstationListName,
    }).then((result) => {
      setWorkplaces([...result.items]);
    });
  }, []);

  useEffect(() => {
    if (Object.keys(reportDocumentsFilter).length > 0) {
      const existsFiltersDocuments: any = {};
      Object.keys(reportDocumentsFilter).map((key) => {
        if (reportDocumentsFilter[key]) {
          if (Array.isArray(reportDocumentsFilter[key])) {
            if (reportDocumentsFilter[key].length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else if (isObject(reportDocumentsFilter[key])) {
            if (Object.keys(reportDocumentsFilter[key]).length > 0) {
              existsFiltersDocuments[key] = reportDocumentsFilter[key];
            }
          } else {
            existsFiltersDocuments[key] = reportDocumentsFilter[key];
          }
        }
      });
      const tempFilters: any = {};
      const tempDisplayFilters: any = {};
      console.log("existsFiltersDocuments: ", existsFiltersDocuments);
      Object.keys(existsFiltersDocuments).map((key) => {
        if (key === "DateForRevision") {
          tempFilters[key] = {
            start:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].startDate).isValid() &&
                moment(existsFiltersDocuments[key].startDate).format("YYYY-MM-DD")) ||
              null,
            end:
              (existsFiltersDocuments[key] &&
                moment(existsFiltersDocuments[key].endDate).isValid() &&
                moment(existsFiltersDocuments[key].endDate).format("YYYY-MM-DD")) ||
              null,
          };
          tempDisplayFilters[key] = `Дата пересмотра от ${moment(existsFiltersDocuments[key].startDate).format(
            "DD.MM.YYYY",
          )} до ${moment(existsFiltersDocuments[key].endDate).format("DD.MM.YYYY")}`;
        } else if (
          key === "Collection" ||
          key === "Department" ||
          key === "Sector" ||
          key === "Process" ||
          key === "Lines" ||
          key === "DocType" ||
          key === "WorkPlaces" ||
          key === "Status"
        ) {
          tempFilters[key] = existsFiltersDocuments[key].map((item: any) => item.id);
          tempDisplayFilters[key] = existsFiltersDocuments[key].map((item: any) => item.name);
        } else if (key === "AuthorEmail" || key === "ResponsibleForRevisionEmail") {
          tempFilters[key] = `${existsFiltersDocuments[key][0]["value"]}*`;
          tempDisplayFilters[key] = existsFiltersDocuments[key][0]["label"];
        } else if (key === "Critical") {
          tempFilters[key] = (existsFiltersDocuments[key] === "Критичный" && true) || false;
          tempDisplayFilters[key] = existsFiltersDocuments[key];
        } else if (
          key === "Equipments_Title" ||
          key === "Equipments_Manufacturer" ||
          key === "Equipments_Model" ||
          key === "Equipments_TypeEquipment" ||
          key === "Equipments_SAP"
        ) {
          if (!Array.isArray(tempFilters["Equipments"])) {
            tempFilters["Equipments"] = [];
          }
          tempFilters["Equipments"] = [
            ...tempFilters["Equipments"],
            ...existsFiltersDocuments[key].map((equipment: any) => `${equipment.id}*`),
          ];
          tempDisplayFilters[key] = existsFiltersDocuments[key].map((equipment: any) => `${equipment.name}`);
        }
      });
      if (searchQuery) {
        Object.assign(
          tempFilters,
          buildDocumentSearchFilter(searchQuery, searchByPartialMatch || searchByContent),
        );
        if (searchByContent) {
          tempDisplayFilters["Search"] = `Поиск по тексту: ${searchQuery}`;
        } else if (searchByPartialMatch) {
          tempDisplayFilters["Search"] = `Поиск по частичному совпадению: ${searchQuery}`;
        } else {
          tempDisplayFilters["Search"] = `Поиск: ${searchQuery}`;
        }
      }
      setFilters({ ...tempFilters });
      setDisplayFilters({ ...tempDisplayFilters });
      if (JSON.stringify(filtersParams) !== JSON.stringify(existsFiltersDocuments)) {
        setFiltersParams(existsFiltersDocuments);
      }
    } else {
      setSearchQuery("");
    }
  }, [reportDocumentsFilter]);

  useEffect(() => {
    if (searchQuery) {
      setFilters((prevState: any) => {
        const next = { ...prevState };
        delete next["Title"];
        delete next["Code"];
        delete next["Index"];
        delete next["$or"];
        return {
          ...next,
          ...buildDocumentSearchFilter(searchQuery, searchByPartialMatch || searchByContent),
        };
      });
      if (searchByContent) {
        setDisplayFilters((prevState: any) => {
          return { ...prevState, Search: `Поиск по тексту: ${searchQuery}` };
        });
      } else if (searchByPartialMatch) {
        setDisplayFilters((prevState: any) => {
          return { ...prevState, Search: `Поиск по частичному совпадению: ${searchQuery}` };
        });
      } else {
        setDisplayFilters((prevState: any) => {
          return { ...prevState, Search: `Поиск: ${searchQuery}` };
        });
      }
      setGetListDocuments(false);
    } else if (
      !searchQuery &&
      Object.keys(filters).length > 0 &&
      (filters["Title"] || filters["Code"] || filters["Index"] || filters["$or"])
    ) {
      setFilters((prevState: any) => {
        if (!prevState) return prevState;
        const next = { ...prevState };
        delete next["Title"];
        delete next["Code"];
        delete next["Index"];
        delete next["$or"];
        return next;
      });
      setDisplayFilters((prevState: any) => {
        if (prevState && prevState.hasOwnProperty("Search")) {
          delete prevState["Search"];
          return { ...prevState };
        } else {
          return prevState;
        }
      });
      setGetListDocuments(false);
    }
  }, [searchQuery, searchByPartialMatch, searchByContent]);

  useEffect(() => {
    if (
      collections.length > 0 &&
      Object.keys(currentUser).length > 0 &&
      currentUser.id > 0 &&
      userFilterCheck &&
      statuses.length > 0 &&
      departments.length > 0
    ) {
      let defaultObj: any = {};
      if (Object.keys(filtersParams).length > 0) {
        Object.keys(filtersParams).forEach((key) => {
          if (filtersParams[key]) {
            defaultObj[key] = filtersParams[key];
          } else {
            defaultObj[key] = null;
          }
        });
        setDefaultValues(defaultObj);
      } else if (defaultUserFilter && Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).length > 0) {
        Object.keys(JSON.parse(defaultUserFilter.MDFullFilters)).forEach((key) => {
          if (JSON.parse(defaultUserFilter.MDFullFilters)[key]) {
            defaultObj[key] = JSON.parse(defaultUserFilter.MDFullFilters)[key];
          } else {
            defaultObj[key] = null;
          }
        });
        setDefaultValues(defaultObj);
      } else {
        let defaultLocationsIds: number[] = [];
        if (currentUser.isCollectionAdmin || currentUser.isCollectionEditor) {
          if (Array.isArray(currentUser.isCollectionAdmin) && currentUser.isCollectionAdmin.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionAdmin];
          }
          if (Array.isArray(currentUser.isCollectionEditor) && currentUser.isCollectionEditor.length > 0) {
            defaultLocationsIds = [...defaultLocationsIds, ...currentUser.isCollectionEditor];
          }
        }
        let unicDefaultLocationsIds: number[] = [..._.uniqWith(defaultLocationsIds, _.isEqual)];
        setDependenceFields({
          Collection:
            (unicDefaultLocationsIds.length > 0 &&
              unicDefaultLocationsIds.map((id) => {
                return {
                  id: id,
                  name: collections.find((collection: any) => collection.ID === id)["Title"],
                  disabled: false,
                };
              })) ||
            null,
          Department: null,
          Sector: null,
          Process: null,
        });
        fields.map((field: any) => {
          if (field.key === "Collection") {
            defaultObj[field.key] =
              (unicDefaultLocationsIds.length > 0 &&
                unicDefaultLocationsIds.map((id) => {
                  return {
                    id: id,
                    name: collections.find((collection: any) => collection.ID === id)["Title"],
                    disabled: false,
                  };
                })) ||
              null;
          } else if (field.key === "Department") {
            defaultObj[field.key] =
              departments
                .filter(
                  (department: any) =>
                    currentUser.department &&
                    department.User_Department &&
                    department.User_Department.indexOf(currentUser.department) !== -1,
                )
                .map((department: any) => {
                  return { id: department.ID, name: department.Title, disabled: false };
                }) || null;
          } else if (field.key === "Status") {
            defaultObj[field.key] = [
              {
                id: docStatuses.public,
                name: "Опубликован",
                disabled: false,
              },
              {
                id: docStatuses.review,
                name: "На пересмотр",
                disabled: false,
              },
            ];
          } else {
            defaultObj[field.key] = null;
          }
        });
        setDefaultValues(defaultObj);
      }
    }
  }, [
    resetFilters,
    collections,
    JSON.stringify(currentUser),
    userFilterCheck,
    reRenderUserFilter,
    statuses,
    departments,
  ]);

  useEffect(() => {
    if (isDefaultDepartment) {
      setDefaultValues((prevState) => {
        return { ...prevState, Department: null };
      });
    }
  }, [isDefaultDepartment]);

  return (
    <FlexCol className="relative">
      {customLoading && <LoadingOpBg />}
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some((key) => reportDocumentsFilter[key]) && (
          <div
            onClick={() => {
              setDisplayFilters({});
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[14px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap border-b"
          >
            <div className="flex flex-col">Сбросить фильтры</div>
            <div className="flex flex-col pt-1">
              <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect width="16" height="16" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
      <Form
        type="report_documents_filters"
        setFormData={setReportDocumentsFilter}
        fieldsForm={fields}
        defaultValues={defaultValues}
        setDependenceFields={setDependenceFields}
      />
      {Object.keys(reportDocumentsFilter).length > 0 &&
        Object.keys(reportDocumentsFilter).some((key) => reportDocumentsFilter[key]) && (
          <div
            onClick={() => {
              setDisplayFilters({});
              setFiltersParams({});
              setReportDocumentsFilter({});
              setFilters({});
              setResetFiters(!resetFilters);
              setGetListDocuments(false);
            }}
            className="p-5 flex flex-row group items-center text-[12px] text-[#637381] cursor-pointer gap-x-2 flex-nowrap"
          >
            <div className="flex flex-col group-hover:underline">Сбросить фильтры</div>
            <div className="flex flex-col pt-1">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_33_4954)">
                  <path
                    d="M5.9998 5.39995L1.4248 0.824951C1.25605 0.656201 0.993555 0.656201 0.824805 0.824951C0.656055 0.993701 0.656055 1.2562 0.824805 1.42495L5.3998 5.99995L0.824805 10.575C0.656055 10.7437 0.656055 11.0062 0.824805 11.175C0.993555 11.3437 1.25605 11.3437 1.4248 11.175L5.9998 6.59995L10.5748 11.175C10.7436 11.3437 11.0061 11.3437 11.1748 11.175C11.2498 11.1 11.3061 10.9875 11.3061 10.875C11.3061 10.7625 11.2686 10.65 11.1748 10.575L6.5998 5.99995L11.1748 1.42495C11.2498 1.34995 11.3061 1.23745 11.3061 1.12495C11.3061 1.01245 11.2686 0.899951 11.1748 0.824951C11.0061 0.656201 10.7436 0.656201 10.5748 0.824951L5.9998 5.39995Z"
                    fill="#637381"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_33_4954">
                    <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        )}
    </FlexCol>
  );
}

export function ReportDocuments() {
  const [filters, setFilters] = useState<any>({});
  const [searchQuery, setSearchQuery] = useState("");
  const [searchByPartialMatch, setSearchByPartialMatch] = useState(false);
  const [searchByContent, setSearchByContent] = useState(false);
  const [nextPage, setNextPage] = useState<any>(null);
  const [listDocuments, setListDocuments] = useState<any>([]);
  const [tempListDocuments, setTempListDocuments] = useState<any>([]);
  const [esRawResults, setEsRawResults] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const [customLoading, setCustomLoading] = useState(false);
  const [getListDocuments, setGetListDocuments] = useState(false);
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const [displayFilters, setDisplayFilters] = useState<any>({});
  const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
  const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
  const [filtersParams, setFiltersParams] = useState({});
  const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
  const [userFilterCheck, setUserFilterCheck] = useState(false);
  const [reRenderUserFilter, setReRenderUserFilter] = useState(null);

  const debouncedSearchQuery = useDebounce<string>(searchQuery, 500);
  const [scrollDown, setScrollDown] = useState(false);

  const [allLoading, setAllLoading] = useState(false);
  const [openImportExel, setOpenImportExel] = useState(false);
  const [elasticLoading, setElasticLoading] = useState(false);

  const [tableHeaderContentExel, setTableHeaderContentExel] = useState<any>({
    Title: {
      title: "Ссылка на документ",
      width: 50,
    },
    Code: {
      title: "Код документа",
      width: 50,
    },
    Collection: {
      title: "Коллекция",
      width: 50,
    },
    Department: {
      title: "Подразделения/Функция",
      width: 50,
    },
    Sector: {
      title: "Колонна/Направление/Отдел",
      width: 50,
    },
    DocType: {
      title: "Тип документа",
      width: 50,
    },
    Version: {
      title: "Номер версии документа",
      width: 50,
    },
    AuthorEmail: {
      title: "Создатель документа",
      width: 50,
    },
    PublicationDate: {
      title: "Дата публикации документа",
      width: 50,
    },
    Status: {
      title: "Текущий статус документа",
      width: 50,
    },
    DateForRevision: {
      title: "Дата пересмотра документа",
      width: 50,
    },
    ResponsibleForRevisionEmail: {
      title: "Ответственный за пересмотр документа",
      width: 50,
    },
    Critical: {
      title: "Критичность документа",
      width: 50,
    },
    Lines: {
      title: "Линия ролива",
      width: 50,
    },
    Equipments_SAP: {
      title: "SAP № технического места",
      width: 50,
    },
    Equipments_Manufacturer: {
      title: "Производитель оборудования",
      width: 50,
    },
    Equipments_Model: {
      title: "Модель оборудования",
      width: 50,
    },
    Equipments_TypeEquipment: {
      title: "Тип оборудования",
      width: 50,
    },
  });

  function handleSearch(value: string) {
    setSearchQuery(value);
  }

  const handleToggleSearchByPartialMatch = () => {
    setSearchByPartialMatch((previousValue) => !previousValue);
  };

  const handleToggleSearchByContent = () => {
    setSearchByContent((prev) => !prev);
  };

  const passesReportMainDocumentListFilter = (item: any): boolean => {
    if (!item.MainDocument) return true;
    const statusId = item.Status?.get_lookupId?.();
    return statusId === docStatuses.approval || statusId === docStatuses.cancel || statusId === docStatuses.revision;
  };

  const filterElasticResults = (results: any[]): any[] => {
    return results.filter((doc: any) => {
      if (!passesReportMainDocumentListFilter(doc)) return false;
      if (filters.Status) {
        const ids = (Array.isArray(filters.Status) ? filters.Status : [filters.Status]).map((id: any) => Number(id));
        const docStatusId = doc.Status?.id ?? doc.Status?.ID ?? doc.Status?.get_lookupId?.() ?? null;
        if (!ids.includes(Number(docStatusId))) return false;
      }
      if (filters.Collection) {
        const ids = Array.isArray(filters.Collection) ? filters.Collection : [filters.Collection];
        if (!ids.includes(doc.Collection?.id)) return false;
      }
      if (filters.Department) {
        const ids = Array.isArray(filters.Department) ? filters.Department : [filters.Department];
        if (!ids.includes(doc.Department?.id)) return false;
      }
      if (filters.Sector) {
        const ids = Array.isArray(filters.Sector) ? filters.Sector : [filters.Sector];
        if (!ids.includes(doc.Sector?.id)) return false;
      }
      if (filters.Process) {
        const ids = Array.isArray(filters.Process) ? filters.Process : [filters.Process];
        if (!ids.includes(doc.ColumnBlockArea?.id)) return false;
      }
      if (filters.DocType) {
        const ids = Array.isArray(filters.DocType) ? filters.DocType : [filters.DocType];
        if (!ids.includes(doc.DocType?.id)) return false;
      }
      if (filters.Critical !== undefined) {
        if (doc.Critical !== filters.Critical) return false;
      }
      if (filters.ResponsibleForRevisionEmail) {
        const email = (doc.ResponsibleForRevisionEmail || doc.ResponsibleForRevision?.Email || "").toLowerCase();
        if (!email.startsWith(filters.ResponsibleForRevisionEmail.replace("*", "").toLowerCase())) return false;
      }
      if (filters.AuthorEmail) {
        const email = (doc.AuthorEmail || "").toLowerCase();
        if (!email.startsWith(filters.AuthorEmail.replace("*", "").toLowerCase())) return false;
      }
      return true;
    });
  };

  const esContentResults = useMemo(() => {
    if (
      !debouncedSearchQuery.length ||
      (!searchByPartialMatch && !searchByContent) ||
      isCodeIndexQuery(debouncedSearchQuery)
    ) {
      return [];
    }
    return filterElasticResults(esRawResults);
  }, [esRawResults, debouncedSearchQuery, searchByPartialMatch, searchByContent, JSON.stringify(filters)]);

  useEffect(() => {
    if (
      !debouncedSearchQuery.length ||
      (!searchByPartialMatch && !searchByContent) ||
      isCodeIndexQuery(debouncedSearchQuery)
    ) {
      setEsRawResults([]);
      setElasticLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchElastic() {
      setElasticLoading(true);
      try {
        const fetchElasticResultsWithFallback = async (
          searchFn: (query: string, from?: number) => Promise<any[]>,
        ): Promise<any[]> => {
          const rowLimit = 100;
          const minFilteredResults = 20;
          const maxRequests = 20;
          let from = 0;
          let allResults: any[] = [];
          let filteredResults: any[] = [];
          let hasMore = true;
          let requestsCount = 0;

          while (hasMore && filteredResults.length < minFilteredResults && requestsCount < maxRequests) {
            const chunk = await searchFn(debouncedSearchQuery, from);
            requestsCount += 1;
            if (!chunk.length) {
              hasMore = false;
              continue;
            }

            allResults = [...allResults, ...chunk];
            filteredResults = filterElasticResults(allResults);
            from += rowLimit;
          }

          return filteredResults;
        };

        const esTitlePromise = fetchElasticResultsWithFallback(elasticSearchByTitleRaw);
        const esTextPromise = searchByContent
          ? fetchElasticResultsWithFallback(elasticSearchByTextRaw)
          : Promise.resolve([] as any[]);

        const [titleResults, textResults] = await Promise.all([esTitlePromise, esTextPromise]);
        if (cancelled) return;

        const esMap = new Map<number, any>();
        for (const doc of titleResults) {
          esMap.set(doc.ID, doc);
        }
        for (const doc of textResults) {
          const existing = esMap.get(doc.ID);
          if (existing) {
            esMap.set(doc.ID, {
              ...doc,
              searchMeta: {
                ...doc.searchMeta,
                foundBy: "both",
                titleHighlightedText: existing.searchMeta?.highlightedText || "",
              },
            });
          } else {
            esMap.set(doc.ID, doc);
          }
        }

        const results = [...esMap.values()];
        const emails = results.flatMap((doc: any) =>
          [doc.AuthorEmail, doc.ResponsibleForRevisionEmail].filter(Boolean),
        );
        if (emails.length) dispatch(addUsers(emails));
        setEsRawResults(results);
      } catch (error) {
        if (!cancelled) console.error("ошибка поиска через Elasticsearch");
      } finally {
        if (!cancelled) {
          setElasticLoading(false);
        }
      }
    }

    fetchElastic();
    return () => {
      cancelled = true;
      setElasticLoading(false);
    };
  }, [searchByPartialMatch, searchByContent, debouncedSearchQuery]);

  useEffect(() => {
    const controller = new AbortController();
    let cancelled = false;
    setTempListDocuments([]);
    setListDocuments([]);
    setNextPage(null);
    if (Object.keys(filters).length > 0) {
      setCustomLoading(true);
      getItemsRequest({
        listName: myDocumentsWithRelationsListName,
        rowLimit: 50,
        filters,
        sortOrder: { name: "ID", desc: true },
        signal: controller.signal,
      })
        .then((results: any) => {
          if (cancelled) return;
          const { items, nextPage } = results;
          let emails: any = [];
          items.map((item: any) => {
            if (item.AuthorEmail) {
              emails = [...emails, item.AuthorEmail];
            }
            if (item.ResponsibleForRevisionEmail) {
              emails = [...emails, item.ResponsibleForRevisionEmail];
            }
          });
          if (items.length > 0) {
            dispatch(addUsers(emails));
            const filteredItems = items.filter(passesReportMainDocumentListFilter);
            setTempListDocuments(filteredItems);
            setGetListDocuments(true);
            setNextPage(nextPage);
          } else {
            setTempListDocuments([]);
            setListDocuments([]);
            setGetListDocuments(true);
            setNextPage(null);
          }
          setCustomLoading(false);
        })
        .catch((err: any) => {
          if (err?.name === "CanceledError" || err?.code === "ERR_CANCELED") return;
          console.error("ошибка загрузки документов", err);
          setCustomLoading(false);
        });
    } else {
      setCustomLoading(false);
      setGetListDocuments(false);
    }
    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [JSON.stringify(filters), searchByPartialMatch, searchByContent]);

  useEffect(() => {
    if (nextPage && getListDocuments && scrollDown && Object.keys(filters).length > 0) {
      getItemsRequest({
        listName: myDocumentsWithRelationsListName,
        rowLimit: 50,
        filters,
        nextPage,
        sortOrder: { name: "ID", desc: true },
      }).then((results: any) => {
        const { items, nextPage } = results;
        let emails: any = [];
        items.map((item: any) => {
          if (item.AuthorEmail) {
            emails = [...emails, item.AuthorEmail];
          }
          if (item.ResponsibleForRevisionEmail) {
            emails = [...emails, item.ResponsibleForRevisionEmail];
          }
        });
        dispatch(addUsers(emails));
        const filteredItems = items.filter(passesReportMainDocumentListFilter);
        setTempListDocuments((prevState: any) => [...prevState, ...filteredItems]);
        setNextPage(nextPage);
        setScrollDown(false);
      });
    }
  }, [nextPage, searchByPartialMatch, searchByContent, scrollDown, JSON.stringify(filters)]);

  useEffect(() => {
    let combined = [...tempListDocuments];

    if (debouncedSearchQuery) {
      const esById = new Map(esContentResults.map((d: any) => [d.ID, d]));

      combined = combined.map((d: any) => {
        const esMatch = esById.get(d.ID);
        if (esMatch?.searchMeta) return { ...d, searchMeta: esMatch.searchMeta };
        return { ...d, searchMeta: { foundBy: "title" } };
      });

      const spIds = new Set(combined.map((d: any) => d.ID));
      const esOnly = esContentResults.filter((d: any) => !spIds.has(d.ID));
      const esOnlyOther = esOnly.filter((d: any) => d.searchMeta?.foundBy !== "content");
      const esOnlyContent = esOnly.filter((d: any) => d.searchMeta?.foundBy === "content");
      combined = [...combined, ...esOnlyOther, ...esOnlyContent];
    }

    const seen = new Set<number>();
    const deduped = combined.filter((d: any) => {
      if (seen.has(d.ID)) return false;
      seen.add(d.ID);
      return true;
    });

    setListDocuments(deduped);
  }, [tempListDocuments, esContentResults, customLoading, debouncedSearchQuery]);

  useEffect(() => {
    let tempStr = "";
    Object.keys(displayFilters).map((key: string, idx: number) => {
      if (idx <= 3) {
        if (Array.isArray(displayFilters[key])) {
          displayFilters[key].map((item: string, idx: number) => {
            if (displayFilters[key].length - 1 === idx) {
              tempStr += item;
            } else {
              tempStr += `${item}, `;
            }
          });
        } else {
          tempStr += `${displayFilters[key]}`;
        }
        tempStr += ", ";
      }
    });
    tempStr = tempStr.slice(0, -2);
    if (Object.keys(displayFilters).length > 4) {
      tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`;
    }
    setDisplayFiltersStr(tempStr);
  }, [displayFilters]);

  useEffect(() => {
    if (openImportExel) {
      setAllLoading(true);
      async function fetchData() {
        const importFilter = { ...filters };
        delete importFilter["Code"];
        delete importFilter["Index"];
        const results = await getItemsRequest({
          listName: myDocumentsWithRelationsListName,
          rowLimit: 1000000,
          filters: searchQuery && { ...importFilter, ...{ ID: listDocuments.map(document => document.ID) } } || importFilter,
          sortOrder: { name: "ID", desc: true },
        });
        const { items } = results;
        const filteredItems = items.filter(passesReportMainDocumentListFilter);
        if (filteredItems.length > 0) {
          const itemsExport = [
            ...filteredItems.filter(
              (item: any) =>
                !(
                  item.MainDocument &&
                  (item.Status.get_lookupId() === docStatuses.public ||
                    item.Status.get_lookupId() === docStatuses.review)
                ),
            ),
          ];
          let exportColumns: any = [];
          Object.keys(tableHeaderContentExel).map((key: any) => {
            exportColumns = [
              ...exportColumns,
              {
                header: tableHeaderContentExel[key]["title"],
                key: key,
                width: tableHeaderContentExel[key]["width"],
              },
            ];
          });
          let exportTemp: any = [];
          itemsExport.forEach((item: any) => {
            let color = "000000",
              lines: any = "-",
              sap: any = "-",
              manufacturer: any = "-",
              model: any = "-",
              typeEquipment: any = "-";
            if (item.Status.get_lookupId() === 3) {
              if (moment().unix() > moment(item.DateForRevision).unix()) {
                color = "D36E6E";
              } else if (moment().unix() > moment(item.DateForRevision).subtract(30, "days").unix()) {
                color = "EAD16E";
              }
            }
            if (item.lines.length > 0) {
              lines = item.lines.map((line: any) => (line && `${line.get_lookupValue()},\u000A`) || `,\u000A`).join("");
              lines = lines.slice(0, -7);
            }
            if (item.eq.length > 0) {
              sap = item.eq.map((item: any) => `${item.sap},\u000A`).join("");
              sap = sap.slice(0, -7);
              manufacturer = item.eq.map((item: any) => `${item.manufacturer},\u000A`).join("");
              manufacturer = manufacturer.slice(0, -7);
              model = item.eq.map((item: any) => `${item.model},\u000A`).join("");
              model = model.slice(0, -7);
              typeEquipment = item.eq.map((item: any) => `${item.typeEquipment},\u000A`).join("");
              typeEquipment = typeEquipment.slice(0, -7);
            }
            exportTemp = [
              ...exportTemp,
              {
                Title: {
                  text: item.Title,
                  hyperlink: `${siteUrl}/dashboard/1/documents?documentCard=${(item.MainDocument && item.MainDocument.id) || item.ID}${(item.MainDocument && `&version=${item.ID}`) || ""}`,
                },
                Code: `${item.Code}.${item.Index}`,
                Collection: item.Collection.get_lookupValue(),
                Department: item.Department.get_lookupValue(),
                Sector: item.Sector.get_lookupValue(),
                DocType: item.DocType.get_lookupValue(),
                Version: item.version,
                AuthorEmail: item.AuthorEmail,
                PublicationDate:
                  (!item.MainDocument &&
                    (item.Status.get_lookupId() === 3 || item.Status.get_lookupId() === 8) &&
                    moment(item.PublicationDate).format("DD.MM.YYYY")) ||
                  "Не опубликован",
                Status: item.Status.get_lookupValue(),
                DateForRevision: {
                  richText: [
                    {
                      font: { size: 16, color: { argb: `${color}` }, name: "Calibri", family: 2, scheme: "minor" },
                      text: moment(item.DateForRevision).format("DD.MM.YYYY"),
                    },
                  ],
                },
                ResponsibleForRevisionEmail: item.ResponsibleForRevisionEmail || item.ResponsibleForRevision.get_email(),
                Critical: (item.Critical && "Критичный") || "Не критичный",
                Lines: lines,
                Equipments_SAP: sap,
                Equipments_Manufacturer: manufacturer,
                Equipments_Model: model,
                Equipments_TypeEquipment: typeEquipment,
              },
            ];
          });
          const exportData = { columns: [...exportColumns], data: [...exportTemp] };
          const fileName = "DocumentsReport";
          const type = "report_documents";
          setAllLoading(false);
          exportExcelFile(exportData, fileName, type, setOpenImportExel);
          setOpenImportExel(false);
        } else {
          setAllLoading(false);
          setOpenImportExel(false);
        }
      }
      fetchData();
    }
  }, [openImportExel]);

  return (
    <FlexRow className="scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
      <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen">
        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <ReportDocumentsFilters
            setGetListDocuments={setGetListDocuments}
            setFilters={setFilters}
            setSearchQuery={setSearchQuery}
            searchQuery={debouncedSearchQuery}
            searchByPartialMatch={searchByPartialMatch}
            searchByContent={searchByContent}
            filters={filters}
            filtersParams={filtersParams}
            defaultUserFilter={defaultUserFilter}
            setFiltersParams={setFiltersParams}
            setDisplayFilters={setDisplayFilters}
            userFilterCheck={userFilterCheck}
            reRenderUserFilter={reRenderUserFilter}
          />
        </FlexCol>
      </FlexCol>
      <FlexCol className="grow w-[calc(100%-320px)]">
        <FlexCol className="w-full">
          <FlexRow className="px-7.5 h-[76px] border-b justify-between items-center shrink-0">
            <FlexCol className="w-full">
              <nav className="flex gap-5 justify-between w-full" aria-label="Breadcrumb">
                <FlexCol className="grow">
                  <ol className="inline-flex gap-2 items-center">
                    <li className="inline-flex items-center" aria-current="page">
                      <Link
                        to="/dashboard/1/reports"
                        className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer"
                      >
                        <ReportIcon />
                        <span>Отчеты</span>
                      </Link>
                    </li>
                    <li className="inline-flex items-center" aria-current="page">
                      <span className="text-body-color">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                            fill={"#637381"}
                          />
                        </svg>
                      </span>
                    </li>
                    <li className="inline-flex items-center min-w-[190px]" aria-current="page">
                      <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                        <FileIcon />
                        <span>Реестр документов</span>
                      </div>
                    </li>
                    <li className="inline-flex items-center" aria-current="page">
                      <span className="text-body-color">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M16.2 8.55001L10.3781 2.64376C10.125 2.39064 9.73126 2.39064 9.47813 2.64376C9.22501 2.89689 9.22501 3.29064 9.47813 3.54376L14.2031 8.35314H2.25001C1.91251 8.35314 1.63126 8.63439 1.63126 8.97189C1.63126 9.30939 1.91251 9.61876 2.25001 9.61876H14.2594L9.47813 14.4844C9.22501 14.7375 9.22501 15.1313 9.47813 15.3844C9.59063 15.4969 9.75938 15.5531 9.92813 15.5531C10.0969 15.5531 10.2656 15.4969 10.3781 15.3563L16.2 9.45001C16.4531 9.19689 16.4531 8.80314 16.2 8.55001Z"
                            fill={"#637381"}
                          />
                        </svg>
                      </span>
                    </li>
                    {(Object.keys(filters).length === 0 && (
                      <li className="inline-flex items-center" aria-current="page">
                        <div className="inline-flex items-center space-x-2 text-base font-medium">
                          Фильтры не выбраны
                        </div>
                      </li>
                    )) || (
                        <li className="inline-flex items-center" aria-current="page">
                          <div className="inline-flex items-center space-x-2 text-base font-medium">
                            {displayFiltersStr}
                          </div>
                        </li>
                      )}
                  </ol>
                </FlexCol>
                <FlexRow className="gap-2 items-center">
                  <FavoriteButtonFilters
                    filters={(Object.keys(filters).length > 0 && JSON.stringify(filters)) || ""}
                    displayFilters={(Object.keys(displayFilters).length > 0 && JSON.stringify(displayFilters)) || ""}
                    reRenderFilterSettings={reRenderFilterSettings}
                    setReRenderFilterSettings={setReRenderFilterSettings}
                    filtersParams={(Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams)) || ""}
                    type="report_docs"
                  />
                  <FavoriteFiltersList
                    reRenderTableFlag={setGetListDocuments}
                    reRenderFilterSettings={reRenderFilterSettings}
                    setReRenderFilterSettings={setReRenderFilterSettings}
                    setFiltersParams={setFiltersParams}
                    type="report_docs"
                    filtersParams={(Object.keys(filtersParams).length > 0 && JSON.stringify(filtersParams)) || ""}
                    listQuestions={myDocumentsListName}
                    setDefaultUserFilter={setDefaultUserFilter}
                    setUserFilterCheck={setUserFilterCheck}
                    userFilterCheck={userFilterCheck}
                    setReRenderUserFilter={setReRenderUserFilter}
                  />
                </FlexRow>
              </nav>
            </FlexCol>
          </FlexRow>
          <FlexRow className="px-7.5 pt-3.5 pb-3.5 gap-x-2.5">
            <FlexCol className="grow">
              <FlexRow className="gap-x-2.5">
                <SearchUI
                  placeholder={
                    searchByPartialMatch || searchByContent
                      ? "Найти документ по частичному совпадению названия или кода документа"
                      : "Найти документ по названию или коду документа"
                  }
                  defaultValue={searchQuery}
                  onClick={handleSearch}
                />
                <Button
                  classBg="btn-white min-w-[200px]"
                  shadow={true}
                  typeIcon="download"
                  icon={true}
                  text="Скачать в Excel"
                  open={openImportExel}
                  setOpen={setOpenImportExel}
                />
              </FlexRow>
              <FlexRow className="mb-[12px] mt-[5px] items-center justify-between">
                <FlexRow className="gap-x-5 items-center">
                  <label className="flex gap-x-2 items-center cursor-pointer select-none">
                    <CustomCheckbox checked={searchByPartialMatch} onChange={handleToggleSearchByPartialMatch}>
                      <span className="text-sm text-[#637381]">Искать по частичному совпадению</span>
                    </CustomCheckbox>
                  </label>
                  <label className="flex gap-x-2 items-center cursor-pointer select-none">
                    <CustomCheckbox checked={searchByContent} onChange={handleToggleSearchByContent}>
                      <span className="text-sm text-[#637381]">Искать по тексту документа</span>
                    </CustomCheckbox>
                  </label>
                </FlexRow>
                {searchQuery.length > 0 && (
                  <span className="text-sm text-[#637381]">Найдено документов: {listDocuments.length}</span>
                )}
              </FlexRow>
            </FlexCol>
          </FlexRow>
          <FlexRow className="px-7.5">
            <ReportDocumentsTable
              data={listDocuments}
              customLoading={customLoading || statusUsers === "LOADING" || elasticLoading}
              nextPage={nextPage}
              searchQuery={searchQuery}
              setScrollDown={setScrollDown}
              filters={filters}
            />
          </FlexRow>
        </FlexCol>
        <Modal zIndex={120} open={openImportExel} toggleDialog={setOpenImportExel} modalClassName="min-h-px">
          {allLoading && (
            <FlexCol className="gap-5 justify-center items-center mt-3">
              <Loading />
              <span>
                Готовим файл для скачивания <br />
                Пожалуйста подождите...
              </span>
            </FlexCol>
          )}
        </Modal>
      </FlexCol>
    </FlexRow>
  );
}
